import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';

class PresencaDatatables extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const event = this.props.presenca.selectedEvent;

        if (!event)
            return;

        const events = this.props.events;
        const token = this.props.token;

        const presencaRender = function (data, type) {
            if (type === "display") {
                if (data) {
                    let hora = moment(data).format('HH:mm');
                    return '<span class="bg-success" style="padding: 1px 3px; color: white; font-weight: bold;">' + hora + '</span>';
                } else
                    return '';
            } else {
                return data ? "CONFIRMADO" : "NÃO PRESENTE";
            }
        };

        const columns = this.props.presenca.columns;
        const datatablesColumns = [];

        columns.forEach(function (column) {
            datatablesColumns.push({
                data: column.name,
                title: column.label,
                render: column.render === "presenca" ? presencaRender : $.datatable.renders.text()
            });
        });

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/attendance/select',
        });

        const buttons = [
            {
                extend: 'csv',
                text: 'download',
                fieldSeparator: ';',
                filename: 'ListaDePresenca',
            }
        ];

        const order = [[1, "asc"]];
        const pageLength = 100;

        const domClassName = 'events-attendance-limited-datatables';
        const title = 'Lista de presença no evento ' + event.name;
        const subTitle = 'Visualização';

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       order={order}
                       pageLength={pageLength}
                       responsive={true}
                       buttons={buttons}
                       editorCreateVisible={false}
                       editorEditVisible={false}
                       editorRemoveVisible={false}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
            />
        );
    }
}

class Presenca extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const props = this.props;
        const app = props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.PRESENCA)
            return null;

        const presencas = props.presenca;

        if (!presencas.selectedEvent)
            return (
                <div>
                    <h3 className="page-header">Nenhum evento selecionado</h3>
                </div>
            );

        return (
            <div>
                <PresencaDatatables {...this.props} />
            </div>
        );
    }
}

export default Presenca;


// WEBPACK FOOTER //
// src/views/pages/Presenca.jsx